import React from 'react';
import {
  QMultiSelect,
  QMultiSelectProps,
  QSelect,
  QSelectItem,
  QSelectProps,
  SearchResource,
} from '@qualio/ui-components';
import { CodeWithNameTooltip } from './ItemWithCodeAndNameLabel';

type CodeNameLabelProps = { itemName?: string; itemId?: string; domain?: SearchResource };

export const formatCodeNameOptionLabel = (
  option: QSelectItem<React.ReactNode>,
  { context }: { context: 'menu' | 'value' },
): React.ReactNode => {
  const labelProps = (React.isValidElement(option.label) ? option.label.props : {}) as CodeNameLabelProps;
  const code = labelProps.itemId;
  if (context === 'menu' || !code) {
    return option.label;
  }
  return <CodeWithNameTooltip code={code} name={labelProps.itemName} domain={labelProps.domain} />;
};

type WithFormatOptionLabel = {
  formatOptionLabel?: (option: QSelectItem<React.ReactNode>, meta: { context: 'menu' | 'value' }) => React.ReactNode;
};

export const CodeNameMultiSelect = QMultiSelect as unknown as (
  props: QMultiSelectProps<React.ReactNode, string> & WithFormatOptionLabel,
) => React.ReactElement;

export const CodeNameSelect = QSelect as unknown as (
  props: QSelectProps<React.ReactNode, string> & WithFormatOptionLabel,
) => React.ReactElement;
